export const configFile = {
  primaryAccentColor: "purple.700",
  secondaryAccentColor: "purple.600",
};
